import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = { data: null, processing: false, isSuccess: null };

const deleteSavedCourseSlice = createSlice({
  name: "deleteSavedCourse",
  initialState,
  reducers: {
    pending(state, action) {
      state.processing = true;
      state.data = action.payload.courseId;
      state.isSuccess = null;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.processing = false;
      state.isSuccess = true;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      state.isSuccess = false;
      /* TODO: reducer for failure*/
    },
    deleteAll(state) {
      state.processing = true;
    },
    clear() {
      return initialState;
    },
  },
});

const { name, actions, reducer } = deleteSavedCourseSlice;
const deleteSavedCourseAction = createAction(name);
const deleteAllSavedCoursesAction = actions.deleteAll;

export {
  deleteSavedCourseAction,
  deleteAllSavedCoursesAction,
  actions as deleteSavedCourseActions,
  reducer as deleteSavedCourseReducer,
};
